import { createFileRoute } from '@tanstack/react-router'
import RelatoriosPage from '@/pages/relatorios/relatorios-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/relatorio',
)({
  component: function RelatorioRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.RELATORIOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_REPORTS}>
          <RelatoriosPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
